import React from 'react';
import '../../css/views/staticPage.css';
import { Typography } from '@mui/material';
import { NavMenuItemType } from "../../views/nav-menu/NavMenuSubmenuListItem";
import { useObservableBadgeValue } from "../../hooks/observable/useObservableBadgeValue";

interface BadgeProps {
  menuItem: NavMenuItemType;
  isPadding?: boolean;
  type?: 'left' | 'right' | 'mobile';
  mobileClassName?: string;
  static?: boolean;
}

const formatBadgeValue = (value: number): string => {
  if (value > 99) {
    return "99+";
  }
  return value.toString();
}

const Badge: React.FC<BadgeProps> = ({ menuItem, isPadding, type, mobileClassName, static: isStatic }) => {
  const badgeValue = useObservableBadgeValue(menuItem);

  if (!badgeValue || badgeValue <= 0) {
    return <div className="hidden" />;
  }

  if (type === 'mobile') {
    return (
      <Typography variant='body2' className={mobileClassName}>
        { formatBadgeValue(badgeValue) }
      </Typography>
    );
  }

  const className = `badge badge-alert ${isPadding ? 'ss-badge-padding' : ''} ${type ?? ''} ${isStatic ? 'static' : ''}`.trim();
  return (
    <div className={className}>
      { formatBadgeValue(badgeValue) }
    </div>
  );
};

export { Badge }